import {
  Checkbox as MantineCheckbox,
  type CheckboxProps as MantineCheckboxProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type CheckboxProps = CoreComponentProps<MantineCheckboxProps, 'button'>;

export function Checkbox({ testId, view = "all", ...rest }: CheckboxProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineCheckbox data-testid={testId} {...rest} />;
}
